const config = {
  // apiUrl: 'http://192.168.1.50:8080',

   apiUrl: 'https://btt.org.pl/api'
};

export default config;
